/* tslint:disable */
/* eslint-disable */
/**
 * Documents API
 * CDI Documents API
 *
 * The version of the OpenAPI document: 1.33.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import * as runtime from '../runtime';
import { AuthorCreateFromJSON, AuthorCreateToJSON, CategoryCreateFromJSON, CategoryCreateToJSON, CategoryListStructureFromJSON, CategoryListStructureToJSON, CategoryStructureFromJSON, CategoryStructureToJSON, CategoryTreeListStructureFromJSON, CategoryTreeListStructureToJSON, CollectionCreateFromJSON, CollectionCreateToJSON, DocumentArticleFromJSON, DocumentArticleToJSON, DocumentArticleUpdateFromJSON, DocumentArticleUpdateToJSON, DocumentBookCreateFromJSON, DocumentBookCreateToJSON, DocumentBookUpdateFromJSON, DocumentBookUpdateToJSON, DocumentCreatedStructureFromJSON, DocumentCreatedStructureToJSON, DocumentEditFromJSON, DocumentEditToJSON, DocumentExerciseCreateFromJSON, DocumentExerciseCreateToJSON, DocumentExerciseUpdateFromJSON, DocumentExerciseUpdateToJSON, DocumentGenericCreateFromJSON, DocumentGenericCreateToJSON, DocumentGenericUpdateFromJSON, DocumentGenericUpdateToJSON, DocumentItemStructureFromJSON, DocumentItemStructureToJSON, DocumentListStructureFromJSON, DocumentListStructureToJSON, DocumentNewsCreateFromJSON, DocumentNewsCreateToJSON, DocumentNewsUpdateFromJSON, DocumentNewsUpdateToJSON, DocumentTranslationCreateFromJSON, DocumentTranslationCreateToJSON, DocumentTypesListStructureFromJSON, DocumentTypesListStructureToJSON, DocumentVideoCreateFromJSON, DocumentVideoCreateToJSON, DocumentVideoUpdateFromJSON, DocumentVideoUpdateToJSON, DocumentsAuthorsAttachRequestFromJSON, DocumentsAuthorsAttachRequestToJSON, DocumentsPlatformsAttachDocumentsRequestFromJSON, DocumentsPlatformsAttachDocumentsRequestToJSON, DocumentsPlatformsAttachRequestFromJSON, DocumentsPlatformsAttachRequestToJSON, DocumentsUsersIndex200ResponseFromJSON, DocumentsUsersIndex200ResponseToJSON, DocumentsUsersShow200ResponseFromJSON, DocumentsUsersShow200ResponseToJSON, FileMetadataStructureFromJSON, FileMetadataStructureToJSON, LanguageStructureFromJSON, LanguageStructureToJSON, PlatformCreateFromJSON, PlatformCreateToJSON, PlatformItemResponseFromJSON, PlatformItemResponseToJSON, PlatformStructureFromJSON, PlatformStructureToJSON, PublisherCreateFromJSON, PublisherCreateToJSON, SearchCategoriesListStructureFromJSON, SearchCategoriesListStructureToJSON, SearchListStructureFromJSON, SearchListStructureToJSON, StandardErrorResponseFromJSON, StandardErrorResponseToJSON, StandardItemResponseFromJSON, StandardItemResponseToJSON, StandardListResponseFromJSON, StandardListResponseToJSON, TagCreateFromJSON, TagCreateToJSON, TermsAndConditionsArrayFromJSON, TermsAndConditionsArrayToJSON, TermsAndConditionsStructureFromJSON, TermsAndConditionsStructureToJSON, UserCreateFromJSON, UserCreateToJSON, UserUpdateFromJSON, UserUpdateToJSON } from '../models';
/**
 *
 */
export class DocumentsApi extends runtime.BaseAPI {
    /**
     * Allows creating a article document type
     */
    async documentsArticleCreateRaw(requestParameters, initOverrides) {
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling documentsArticleCreate.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters['Authorization'] = await this.configuration.accessToken('keycloakOauth', ['documents-article-create']);
        }
        const response = await this.request({
            path: `/documents/article`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: DocumentArticleToJSON(requestParameters.body)
        }, initOverrides);
        return new runtime.JSONApiResponse(response, jsonValue => DocumentCreatedStructureFromJSON(jsonValue));
    }
    /**
     * Allows creating a article document type
     */
    async documentsArticleCreate(requestParameters, initOverrides) {
        const response = await this.documentsArticleCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Update a article document
     */
    async documentsArticleEditRaw(requestParameters, initOverrides) {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling documentsArticleEdit.');
        }
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling documentsArticleEdit.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters['Authorization'] = await this.configuration.accessToken('keycloakOauth', ['documents-article-edit']);
        }
        const response = await this.request({
            path: `/documents/article/{id}`.replace(`{${'id'}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: DocumentArticleUpdateToJSON(requestParameters.body)
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Update a article document
     */
    async documentsArticleEdit(requestParameters, initOverrides) {
        await this.documentsArticleEditRaw(requestParameters, initOverrides);
    }
    /**
     * Allows setting authors against the document id provided. Expects all authors sent to be correct.
     * Associate authors for the given document id
     */
    async documentsAuthorsAttachRaw(requestParameters, initOverrides) {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling documentsAuthorsAttach.');
        }
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling documentsAuthorsAttach.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters['Authorization'] = await this.configuration.accessToken('keycloakOauth', ['documents-authors-attach']);
        }
        const response = await this.request({
            path: `/documents/{id}/authors`.replace(`{${'id'}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: DocumentsAuthorsAttachRequestToJSON(requestParameters.body)
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Allows setting authors against the document id provided. Expects all authors sent to be correct.
     * Associate authors for the given document id
     */
    async documentsAuthorsAttach(requestParameters, initOverrides) {
        await this.documentsAuthorsAttachRaw(requestParameters, initOverrides);
    }
    /**
     * Add a new author
     * Create a new author
     */
    async documentsAuthorsCreateRaw(requestParameters, initOverrides) {
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling documentsAuthorsCreate.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters['Authorization'] = await this.configuration.accessToken('keycloakOauth', ['documents-authors-create']);
        }
        const response = await this.request({
            path: `/documents/authors`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AuthorCreateToJSON(requestParameters.body)
        }, initOverrides);
        return new runtime.JSONApiResponse(response, jsonValue => DocumentCreatedStructureFromJSON(jsonValue));
    }
    /**
     * Add a new author
     * Create a new author
     */
    async documentsAuthorsCreate(requestParameters, initOverrides) {
        const response = await this.documentsAuthorsCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Allow soft deletion of a single author
     * Allows (soft) deleting a single author
     */
    async documentsAuthorsDeleteRaw(requestParameters, initOverrides) {
        if (requestParameters.authorId === null || requestParameters.authorId === undefined) {
            throw new runtime.RequiredError('authorId', 'Required parameter requestParameters.authorId was null or undefined when calling documentsAuthorsDelete.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters['Authorization'] = await this.configuration.accessToken('keycloakOauth', ['documents-authors-delete']);
        }
        const response = await this.request({
            path: `/documents/authors/{authorId}`.replace(`{${'authorId'}}`, encodeURIComponent(String(requestParameters.authorId))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Allow soft deletion of a single author
     * Allows (soft) deleting a single author
     */
    async documentsAuthorsDelete(requestParameters, initOverrides) {
        await this.documentsAuthorsDeleteRaw(requestParameters, initOverrides);
    }
    /**
     * Delete association between given author and document
     * Delete association between given author and document
     */
    async documentsAuthorsDetachRaw(requestParameters, initOverrides) {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling documentsAuthorsDetach.');
        }
        if (requestParameters.authorId === null || requestParameters.authorId === undefined) {
            throw new runtime.RequiredError('authorId', 'Required parameter requestParameters.authorId was null or undefined when calling documentsAuthorsDetach.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters['Authorization'] = await this.configuration.accessToken('keycloakOauth', ['documents-authors-detach']);
        }
        const response = await this.request({
            path: `/documents/{id}/authors/{authorId}`
                .replace(`{${'id'}}`, encodeURIComponent(String(requestParameters.id)))
                .replace(`{${'authorId'}}`, encodeURIComponent(String(requestParameters.authorId))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Delete association between given author and document
     * Delete association between given author and document
     */
    async documentsAuthorsDetach(requestParameters, initOverrides) {
        await this.documentsAuthorsDetachRaw(requestParameters, initOverrides);
    }
    /**
     * Delete all author association for the given document id
     * Delete all author association for the given document id
     */
    async documentsAuthorsDetachAllRaw(requestParameters, initOverrides) {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling documentsAuthorsDetachAll.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters['Authorization'] = await this.configuration.accessToken('keycloakOauth', ['documents-authors-detach-all']);
        }
        const response = await this.request({
            path: `/documents/{id}/authors`.replace(`{${'id'}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Delete all author association for the given document id
     * Delete all author association for the given document id
     */
    async documentsAuthorsDetachAll(requestParameters, initOverrides) {
        await this.documentsAuthorsDetachAllRaw(requestParameters, initOverrides);
    }
    /**
     * Edit an existing author
     * Edit an existing author
     */
    async documentsAuthorsEditRaw(requestParameters, initOverrides) {
        if (requestParameters.authorId === null || requestParameters.authorId === undefined) {
            throw new runtime.RequiredError('authorId', 'Required parameter requestParameters.authorId was null or undefined when calling documentsAuthorsEdit.');
        }
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling documentsAuthorsEdit.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters['Authorization'] = await this.configuration.accessToken('keycloakOauth', ['documents-authors-edit']);
        }
        const response = await this.request({
            path: `/documents/authors/{authorId}`.replace(`{${'authorId'}}`, encodeURIComponent(String(requestParameters.authorId))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: AuthorCreateToJSON(requestParameters.body)
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Edit an existing author
     * Edit an existing author
     */
    async documentsAuthorsEdit(requestParameters, initOverrides) {
        await this.documentsAuthorsEditRaw(requestParameters, initOverrides);
    }
    /**
     * The list of authors with filters.
     * The list of authors available
     */
    async documentsAuthorsIndexRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }
        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }
        if (requestParameters.ids) {
            queryParameters['ids'] = requestParameters.ids.join(runtime.COLLECTION_FORMATS['csv']);
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters['Authorization'] = await this.configuration.accessToken('keycloakOauth', ['documents-authors-index']);
        }
        const response = await this.request({
            path: `/documents/authors`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters
        }, initOverrides);
        return new runtime.JSONApiResponse(response, jsonValue => StandardListResponseFromJSON(jsonValue));
    }
    /**
     * The list of authors with filters.
     * The list of authors available
     */
    async documentsAuthorsIndex(requestParameters = {}, initOverrides) {
        const response = await this.documentsAuthorsIndexRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Allows searching got an author. Useful for autocomplete.
     * Search for authors
     */
    async documentsAuthorsSearchRaw(requestParameters, initOverrides) {
        if (requestParameters.s === null || requestParameters.s === undefined) {
            throw new runtime.RequiredError('s', 'Required parameter requestParameters.s was null or undefined when calling documentsAuthorsSearch.');
        }
        const queryParameters = {};
        if (requestParameters.s !== undefined) {
            queryParameters['s'] = requestParameters.s;
        }
        if (requestParameters.isFullTextSearch !== undefined) {
            queryParameters['isFullTextSearch'] = requestParameters.isFullTextSearch;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters['Authorization'] = await this.configuration.accessToken('keycloakOauth', ['documents-authors-search']);
        }
        const response = await this.request({
            path: `/documents/authors/search`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters
        }, initOverrides);
        return new runtime.JSONApiResponse(response, jsonValue => StandardListResponseFromJSON(jsonValue));
    }
    /**
     * Allows searching got an author. Useful for autocomplete.
     * Search for authors
     */
    async documentsAuthorsSearch(requestParameters, initOverrides) {
        const response = await this.documentsAuthorsSearchRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Show a single author. Useful for editing
     * Show a single author
     */
    async documentsAuthorsShowRaw(requestParameters, initOverrides) {
        if (requestParameters.authorId === null || requestParameters.authorId === undefined) {
            throw new runtime.RequiredError('authorId', 'Required parameter requestParameters.authorId was null or undefined when calling documentsAuthorsShow.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters['Authorization'] = await this.configuration.accessToken('keycloakOauth', ['documents-authors-show']);
        }
        const response = await this.request({
            path: `/documents/authors/{authorId}`.replace(`{${'authorId'}}`, encodeURIComponent(String(requestParameters.authorId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters
        }, initOverrides);
        return new runtime.JSONApiResponse(response, jsonValue => StandardItemResponseFromJSON(jsonValue));
    }
    /**
     * Show a single author. Useful for editing
     * Show a single author
     */
    async documentsAuthorsShow(requestParameters, initOverrides) {
        const response = await this.documentsAuthorsShowRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Allows creating a book document type
     */
    async documentsBookCreateRaw(requestParameters, initOverrides) {
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling documentsBookCreate.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters['Authorization'] = await this.configuration.accessToken('keycloakOauth', ['documents-book-create']);
        }
        const response = await this.request({
            path: `/documents/book`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: DocumentBookCreateToJSON(requestParameters.body)
        }, initOverrides);
        return new runtime.JSONApiResponse(response, jsonValue => DocumentCreatedStructureFromJSON(jsonValue));
    }
    /**
     * Allows creating a book document type
     */
    async documentsBookCreate(requestParameters, initOverrides) {
        const response = await this.documentsBookCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Update a book information
     */
    async documentsBookEditRaw(requestParameters, initOverrides) {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling documentsBookEdit.');
        }
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling documentsBookEdit.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters['Authorization'] = await this.configuration.accessToken('keycloakOauth', ['documents-book-edit']);
        }
        const response = await this.request({
            path: `/documents/book/{id}`.replace(`{${'id'}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: DocumentBookUpdateToJSON(requestParameters.body)
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Update a book information
     */
    async documentsBookEdit(requestParameters, initOverrides) {
        await this.documentsBookEditRaw(requestParameters, initOverrides);
    }
    /**
     * Allows setting categories against the document id provided. Expects all categories sent to be correct.
     * Associate categories for the given document id
     */
    async documentsCategoriesAttachRaw(requestParameters, initOverrides) {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling documentsCategoriesAttach.');
        }
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling documentsCategoriesAttach.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters['Authorization'] = await this.configuration.accessToken('keycloakOauth', ['documents-categories-attach']);
        }
        const response = await this.request({
            path: `/documents/{id}/categories`.replace(`{${'id'}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: DocumentsAuthorsAttachRequestToJSON(requestParameters.body)
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Allows setting categories against the document id provided. Expects all categories sent to be correct.
     * Associate categories for the given document id
     */
    async documentsCategoriesAttach(requestParameters, initOverrides) {
        await this.documentsCategoriesAttachRaw(requestParameters, initOverrides);
    }
    /**
     * Add a new category
     * Create a new category
     */
    async documentsCategoriesCreateRaw(requestParameters, initOverrides) {
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling documentsCategoriesCreate.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters['Authorization'] = await this.configuration.accessToken('keycloakOauth', ['documents-categories-create']);
        }
        const response = await this.request({
            path: `/documents/categories`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CategoryCreateToJSON(requestParameters.body)
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Add a new category
     * Create a new category
     */
    async documentsCategoriesCreate(requestParameters, initOverrides) {
        await this.documentsCategoriesCreateRaw(requestParameters, initOverrides);
    }
    /**
     * Allow soft deletion of a single category
     * Allows (soft) deleting a single category
     */
    async documentsCategoriesDeleteRaw(requestParameters, initOverrides) {
        if (requestParameters.categoryId === null ||
            requestParameters.categoryId === undefined) {
            throw new runtime.RequiredError('categoryId', 'Required parameter requestParameters.categoryId was null or undefined when calling documentsCategoriesDelete.');
        }
        const queryParameters = {};
        if (requestParameters.locale !== undefined) {
            queryParameters['locale'] = requestParameters.locale;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters['Authorization'] = await this.configuration.accessToken('keycloakOauth', ['documents-categories-delete']);
        }
        const response = await this.request({
            path: `/documents/categories/{categoryId}`.replace(`{${'categoryId'}}`, encodeURIComponent(String(requestParameters.categoryId))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Allow soft deletion of a single category
     * Allows (soft) deleting a single category
     */
    async documentsCategoriesDelete(requestParameters, initOverrides) {
        await this.documentsCategoriesDeleteRaw(requestParameters, initOverrides);
    }
    /**
     * Delete association between given tag and document
     * Delete association between given category and document
     */
    async documentsCategoriesDetachRaw(requestParameters, initOverrides) {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling documentsCategoriesDetach.');
        }
        if (requestParameters.categoryId === null ||
            requestParameters.categoryId === undefined) {
            throw new runtime.RequiredError('categoryId', 'Required parameter requestParameters.categoryId was null or undefined when calling documentsCategoriesDetach.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters['Authorization'] = await this.configuration.accessToken('keycloakOauth', ['documents-categories-detach']);
        }
        const response = await this.request({
            path: `/documents/{id}/categories/{categoryId}`
                .replace(`{${'id'}}`, encodeURIComponent(String(requestParameters.id)))
                .replace(`{${'categoryId'}}`, encodeURIComponent(String(requestParameters.categoryId))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Delete association between given tag and document
     * Delete association between given category and document
     */
    async documentsCategoriesDetach(requestParameters, initOverrides) {
        await this.documentsCategoriesDetachRaw(requestParameters, initOverrides);
    }
    /**
     * Delete all category association for the given document id
     * Delete all category association for the given document id
     */
    async documentsCategoriesDetachAllRaw(requestParameters, initOverrides) {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling documentsCategoriesDetachAll.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters['Authorization'] = await this.configuration.accessToken('keycloakOauth', ['documents-categories-detach-all']);
        }
        const response = await this.request({
            path: `/documents/{id}/categories`.replace(`{${'id'}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Delete all category association for the given document id
     * Delete all category association for the given document id
     */
    async documentsCategoriesDetachAll(requestParameters, initOverrides) {
        await this.documentsCategoriesDetachAllRaw(requestParameters, initOverrides);
    }
    /**
     * Edit an existing category
     * Edit an existing category
     */
    async documentsCategoriesEditRaw(requestParameters, initOverrides) {
        if (requestParameters.categoryId === null ||
            requestParameters.categoryId === undefined) {
            throw new runtime.RequiredError('categoryId', 'Required parameter requestParameters.categoryId was null or undefined when calling documentsCategoriesEdit.');
        }
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling documentsCategoriesEdit.');
        }
        const queryParameters = {};
        if (requestParameters.locale !== undefined) {
            queryParameters['locale'] = requestParameters.locale;
        }
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters['Authorization'] = await this.configuration.accessToken('keycloakOauth', ['documents-categories-edit']);
        }
        const response = await this.request({
            path: `/documents/categories/{categoryId}`.replace(`{${'categoryId'}}`, encodeURIComponent(String(requestParameters.categoryId))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: CategoryCreateToJSON(requestParameters.body)
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Edit an existing category
     * Edit an existing category
     */
    async documentsCategoriesEdit(requestParameters, initOverrides) {
        await this.documentsCategoriesEditRaw(requestParameters, initOverrides);
    }
    /**
     * The list of categories with filters.
     * The list of categories available
     */
    async documentsCategoriesIndexRaw(requestParameters, initOverrides) {
        if (requestParameters.locale === null || requestParameters.locale === undefined) {
            throw new runtime.RequiredError('locale', 'Required parameter requestParameters.locale was null or undefined when calling documentsCategoriesIndex.');
        }
        const queryParameters = {};
        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }
        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }
        if (requestParameters.locale !== undefined) {
            queryParameters['locale'] = requestParameters.locale;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters['Authorization'] = await this.configuration.accessToken('keycloakOauth', ['documents-categories-index']);
        }
        const response = await this.request({
            path: `/documents/categories`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters
        }, initOverrides);
        return new runtime.JSONApiResponse(response, jsonValue => CategoryTreeListStructureFromJSON(jsonValue));
    }
    /**
     * The list of categories with filters.
     * The list of categories available
     */
    async documentsCategoriesIndex(requestParameters, initOverrides) {
        const response = await this.documentsCategoriesIndexRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Show a single category. Useful for editing
     * Show a single category
     */
    async documentsCategoriesShowRaw(requestParameters, initOverrides) {
        if (requestParameters.categoryId === null ||
            requestParameters.categoryId === undefined) {
            throw new runtime.RequiredError('categoryId', 'Required parameter requestParameters.categoryId was null or undefined when calling documentsCategoriesShow.');
        }
        const queryParameters = {};
        if (requestParameters.locale !== undefined) {
            queryParameters['locale'] = requestParameters.locale;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters['Authorization'] = await this.configuration.accessToken('keycloakOauth', ['documents-categories-show']);
        }
        const response = await this.request({
            path: `/documents/categories/{categoryId}`.replace(`{${'categoryId'}}`, encodeURIComponent(String(requestParameters.categoryId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters
        }, initOverrides);
        return new runtime.JSONApiResponse(response, jsonValue => CategoryStructureFromJSON(jsonValue));
    }
    /**
     * Show a single category. Useful for editing
     * Show a single category
     */
    async documentsCategoriesShow(requestParameters, initOverrides) {
        const response = await this.documentsCategoriesShowRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Add a new collection
     * Create a new collection
     */
    async documentsCollectionsCreateRaw(requestParameters, initOverrides) {
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling documentsCollectionsCreate.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters['Authorization'] = await this.configuration.accessToken('keycloakOauth', ['documents-collections-create']);
        }
        const response = await this.request({
            path: `/documents/collections`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CollectionCreateToJSON(requestParameters.body)
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Add a new collection
     * Create a new collection
     */
    async documentsCollectionsCreate(requestParameters, initOverrides) {
        await this.documentsCollectionsCreateRaw(requestParameters, initOverrides);
    }
    /**
     * Allow soft deletion of a single collection
     * Allows (soft) deleting a single collection
     */
    async documentsCollectionsDeleteRaw(requestParameters, initOverrides) {
        if (requestParameters.collectionId === null ||
            requestParameters.collectionId === undefined) {
            throw new runtime.RequiredError('collectionId', 'Required parameter requestParameters.collectionId was null or undefined when calling documentsCollectionsDelete.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters['Authorization'] = await this.configuration.accessToken('keycloakOauth', ['documents-collections-delete']);
        }
        const response = await this.request({
            path: `/documents/collections/{collectionId}`.replace(`{${'collectionId'}}`, encodeURIComponent(String(requestParameters.collectionId))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Allow soft deletion of a single collection
     * Allows (soft) deleting a single collection
     */
    async documentsCollectionsDelete(requestParameters, initOverrides) {
        await this.documentsCollectionsDeleteRaw(requestParameters, initOverrides);
    }
    /**
     * Edit an existing collection
     * Edit an existing collection
     */
    async documentsCollectionsEditRaw(requestParameters, initOverrides) {
        if (requestParameters.collectionId === null ||
            requestParameters.collectionId === undefined) {
            throw new runtime.RequiredError('collectionId', 'Required parameter requestParameters.collectionId was null or undefined when calling documentsCollectionsEdit.');
        }
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling documentsCollectionsEdit.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters['Authorization'] = await this.configuration.accessToken('keycloakOauth', ['documents-collections-edit']);
        }
        const response = await this.request({
            path: `/documents/collections/{collectionId}`.replace(`{${'collectionId'}}`, encodeURIComponent(String(requestParameters.collectionId))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: CollectionCreateToJSON(requestParameters.body)
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Edit an existing collection
     * Edit an existing collection
     */
    async documentsCollectionsEdit(requestParameters, initOverrides) {
        await this.documentsCollectionsEditRaw(requestParameters, initOverrides);
    }
    /**
     * The list of collections with filters.
     * The list of collections available
     */
    async documentsCollectionsIndexRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }
        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters['Authorization'] = await this.configuration.accessToken('keycloakOauth', ['documents-collections-index']);
        }
        const response = await this.request({
            path: `/documents/collections`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters
        }, initOverrides);
        return new runtime.JSONApiResponse(response, jsonValue => StandardListResponseFromJSON(jsonValue));
    }
    /**
     * The list of collections with filters.
     * The list of collections available
     */
    async documentsCollectionsIndex(requestParameters = {}, initOverrides) {
        const response = await this.documentsCollectionsIndexRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Show a single collection. Useful for editing
     * Show a single collection
     */
    async documentsCollectionsShowRaw(requestParameters, initOverrides) {
        if (requestParameters.collectionId === null ||
            requestParameters.collectionId === undefined) {
            throw new runtime.RequiredError('collectionId', 'Required parameter requestParameters.collectionId was null or undefined when calling documentsCollectionsShow.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters['Authorization'] = await this.configuration.accessToken('keycloakOauth', ['documents-collections-show']);
        }
        const response = await this.request({
            path: `/documents/collections/{collectionId}`.replace(`{${'collectionId'}}`, encodeURIComponent(String(requestParameters.collectionId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters
        }, initOverrides);
        return new runtime.JSONApiResponse(response, jsonValue => StandardItemResponseFromJSON(jsonValue));
    }
    /**
     * Show a single collection. Useful for editing
     * Show a single collection
     */
    async documentsCollectionsShow(requestParameters, initOverrides) {
        const response = await this.documentsCollectionsShowRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Allow soft deletion of a single document
     * Allows (soft) deleting a single document
     */
    async documentsDeleteRaw(requestParameters, initOverrides) {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling documentsDelete.');
        }
        if (requestParameters.locale === null || requestParameters.locale === undefined) {
            throw new runtime.RequiredError('locale', 'Required parameter requestParameters.locale was null or undefined when calling documentsDelete.');
        }
        const queryParameters = {};
        if (requestParameters.locale !== undefined) {
            queryParameters['locale'] = requestParameters.locale;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters['Authorization'] = await this.configuration.accessToken('keycloakOauth', ['documents-delete', 'documents-delete-disabled']);
        }
        const response = await this.request({
            path: `/documents/{id}`.replace(`{${'id'}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Allow soft deletion of a single document
     * Allows (soft) deleting a single document
     */
    async documentsDelete(requestParameters, initOverrides) {
        await this.documentsDeleteRaw(requestParameters, initOverrides);
    }
    /**
     * Allows editing a document
     * Allows editing a document
     */
    async documentsEditRaw(requestParameters, initOverrides) {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling documentsEdit.');
        }
        if (requestParameters.locale === null || requestParameters.locale === undefined) {
            throw new runtime.RequiredError('locale', 'Required parameter requestParameters.locale was null or undefined when calling documentsEdit.');
        }
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling documentsEdit.');
        }
        const queryParameters = {};
        if (requestParameters.locale !== undefined) {
            queryParameters['locale'] = requestParameters.locale;
        }
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters['Authorization'] = await this.configuration.accessToken('keycloakOauth', ['documents-edit', 'documents-edit-disabled']);
        }
        const response = await this.request({
            path: `/documents/{id}`.replace(`{${'id'}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: DocumentEditToJSON(requestParameters.body)
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Allows editing a document
     * Allows editing a document
     */
    async documentsEdit(requestParameters, initOverrides) {
        await this.documentsEditRaw(requestParameters, initOverrides);
    }
    /**
     * Allows creating a exercise document type
     */
    async documentsExerciseCreateRaw(requestParameters, initOverrides) {
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling documentsExerciseCreate.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters['Authorization'] = await this.configuration.accessToken('keycloakOauth', ['documents-exercise-create']);
        }
        const response = await this.request({
            path: `/documents/exercise`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: DocumentExerciseCreateToJSON(requestParameters.body)
        }, initOverrides);
        return new runtime.JSONApiResponse(response, jsonValue => DocumentCreatedStructureFromJSON(jsonValue));
    }
    /**
     * Allows creating a exercise document type
     */
    async documentsExerciseCreate(requestParameters, initOverrides) {
        const response = await this.documentsExerciseCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Update a exercise information
     */
    async documentsExerciseEditRaw(requestParameters, initOverrides) {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling documentsExerciseEdit.');
        }
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling documentsExerciseEdit.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters['Authorization'] = await this.configuration.accessToken('keycloakOauth', ['documents-exercise-edit']);
        }
        const response = await this.request({
            path: `/documents/exercise/{id}`.replace(`{${'id'}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: DocumentExerciseUpdateToJSON(requestParameters.body)
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Update a exercise information
     */
    async documentsExerciseEdit(requestParameters, initOverrides) {
        await this.documentsExerciseEditRaw(requestParameters, initOverrides);
    }
    /**
     * Allows creating a generic document type
     */
    async documentsGenericCreateRaw(requestParameters, initOverrides) {
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling documentsGenericCreate.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters['Authorization'] = await this.configuration.accessToken('keycloakOauth', ['documents-generic-create']);
        }
        const response = await this.request({
            path: `/documents/generic`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: DocumentGenericCreateToJSON(requestParameters.body)
        }, initOverrides);
        return new runtime.JSONApiResponse(response, jsonValue => DocumentCreatedStructureFromJSON(jsonValue));
    }
    /**
     * Allows creating a generic document type
     */
    async documentsGenericCreate(requestParameters, initOverrides) {
        const response = await this.documentsGenericCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Update a generic document information
     */
    async documentsGenericEditRaw(requestParameters, initOverrides) {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling documentsGenericEdit.');
        }
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling documentsGenericEdit.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters['Authorization'] = await this.configuration.accessToken('keycloakOauth', ['documents-generic-edit']);
        }
        const response = await this.request({
            path: `/documents/generic/{id}`.replace(`{${'id'}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: DocumentGenericUpdateToJSON(requestParameters.body)
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Update a generic document information
     */
    async documentsGenericEdit(requestParameters, initOverrides) {
        await this.documentsGenericEditRaw(requestParameters, initOverrides);
    }
    /**
     * Returns the documents that are available based on provided filters. Limited to 100 items. Available means with status set to enabled and not soft deleted.
     * A list of documents based on provided (if) filters.
     */
    async documentsIndexRaw(requestParameters, initOverrides) {
        if (requestParameters.locale === null || requestParameters.locale === undefined) {
            throw new runtime.RequiredError('locale', 'Required parameter requestParameters.locale was null or undefined when calling documentsIndex.');
        }
        const queryParameters = {};
        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }
        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }
        if (requestParameters.type !== undefined) {
            queryParameters['type'] = requestParameters.type;
        }
        if (requestParameters.orderByField !== undefined) {
            queryParameters['orderByField'] = requestParameters.orderByField;
        }
        if (requestParameters.orderByType !== undefined) {
            queryParameters['orderByType'] = requestParameters.orderByType;
        }
        if (requestParameters.status) {
            queryParameters['status'] = requestParameters.status.join(runtime.COLLECTION_FORMATS['csv']);
        }
        if (requestParameters.platforms) {
            queryParameters['platforms'] = requestParameters.platforms.join(runtime.COLLECTION_FORMATS['csv']);
        }
        if (requestParameters.resourceFields) {
            queryParameters['resourceFields'] = requestParameters.resourceFields.join(runtime.COLLECTION_FORMATS['csv']);
        }
        if (requestParameters.resourceValues) {
            queryParameters['resourceValues'] = requestParameters.resourceValues.join(runtime.COLLECTION_FORMATS['csv']);
        }
        if (requestParameters.author !== undefined) {
            queryParameters['author'] = requestParameters.author;
        }
        if (requestParameters.title !== undefined) {
            queryParameters['title'] = requestParameters.title;
        }
        if (requestParameters.category !== undefined) {
            queryParameters['category'] = requestParameters.category;
        }
        if (requestParameters.locale !== undefined) {
            queryParameters['locale'] = requestParameters.locale;
        }
        if (requestParameters.language !== undefined) {
            queryParameters['language'] = requestParameters.language;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters['Authorization'] = await this.configuration.accessToken('keycloakOauth', [
                'documents-index',
                'documents-index-draft',
                'documents-index-disabled',
                'documents-index-deleted',
                'documents-news-index',
                'documents-book-index',
                'documents-article-index',
                'documents-generic-index',
                'documents-video-index',
                'documents-exercise-index'
            ]);
        }
        const response = await this.request({
            path: `/documents`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters
        }, initOverrides);
        return new runtime.JSONApiResponse(response, jsonValue => DocumentListStructureFromJSON(jsonValue));
    }
    /**
     * Returns the documents that are available based on provided filters. Limited to 100 items. Available means with status set to enabled and not soft deleted.
     * A list of documents based on provided (if) filters.
     */
    async documentsIndex(requestParameters, initOverrides) {
        const response = await this.documentsIndexRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Returns a list of available languages
     */
    async documentsLanguagesIndexRaw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters['Authorization'] = await this.configuration.accessToken('keycloakOauth', ['documents-languages-index']);
        }
        const response = await this.request({
            path: `/documents/languages`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters
        }, initOverrides);
        return new runtime.JSONApiResponse(response, jsonValue => LanguageStructureFromJSON(jsonValue));
    }
    /**
     * Returns a list of available languages
     */
    async documentsLanguagesIndex(initOverrides) {
        const response = await this.documentsLanguagesIndexRaw(initOverrides);
        return await response.value();
    }
    /**
     * Returns metadata for this the given file
     */
    async documentsMetadataShowRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        if (requestParameters.fileUrl !== undefined) {
            queryParameters['fileUrl'] = requestParameters.fileUrl;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters['Authorization'] = await this.configuration.accessToken('keycloakOauth', ['documents-metadata-show']);
        }
        const response = await this.request({
            path: `/documents/metadata`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters
        }, initOverrides);
        return new runtime.JSONApiResponse(response, jsonValue => FileMetadataStructureFromJSON(jsonValue));
    }
    /**
     * Returns metadata for this the given file
     */
    async documentsMetadataShow(requestParameters = {}, initOverrides) {
        const response = await this.documentsMetadataShowRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Allows creating a news document type
     */
    async documentsNewsCreateRaw(requestParameters, initOverrides) {
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling documentsNewsCreate.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters['Authorization'] = await this.configuration.accessToken('keycloakOauth', ['documents-news-create']);
        }
        const response = await this.request({
            path: `/documents/news`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: DocumentNewsCreateToJSON(requestParameters.body)
        }, initOverrides);
        return new runtime.JSONApiResponse(response, jsonValue => DocumentCreatedStructureFromJSON(jsonValue));
    }
    /**
     * Allows creating a news document type
     */
    async documentsNewsCreate(requestParameters, initOverrides) {
        const response = await this.documentsNewsCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Update a news item
     */
    async documentsNewsEditRaw(requestParameters, initOverrides) {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling documentsNewsEdit.');
        }
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling documentsNewsEdit.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters['Authorization'] = await this.configuration.accessToken('keycloakOauth', ['documents-news-edit']);
        }
        const response = await this.request({
            path: `/documents/news/{id}`.replace(`{${'id'}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: DocumentNewsUpdateToJSON(requestParameters.body)
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Update a news item
     */
    async documentsNewsEdit(requestParameters, initOverrides) {
        await this.documentsNewsEditRaw(requestParameters, initOverrides);
    }
    /**
     * The list of categories that are not childs for one node.
     * The list of not categories node childs
     */
    async documentsNotChildCategoriesRaw(requestParameters, initOverrides) {
        if (requestParameters.categoryId === null ||
            requestParameters.categoryId === undefined) {
            throw new runtime.RequiredError('categoryId', 'Required parameter requestParameters.categoryId was null or undefined when calling documentsNotChildCategories.');
        }
        if (requestParameters.locale === null || requestParameters.locale === undefined) {
            throw new runtime.RequiredError('locale', 'Required parameter requestParameters.locale was null or undefined when calling documentsNotChildCategories.');
        }
        const queryParameters = {};
        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }
        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }
        if (requestParameters.locale !== undefined) {
            queryParameters['locale'] = requestParameters.locale;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters['Authorization'] = await this.configuration.accessToken('keycloakOauth', ['documents-categories-index']);
        }
        const response = await this.request({
            path: `/documents/categories/not/childs/{categoryId}`.replace(`{${'categoryId'}}`, encodeURIComponent(String(requestParameters.categoryId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters
        }, initOverrides);
        return new runtime.JSONApiResponse(response, jsonValue => CategoryListStructureFromJSON(jsonValue));
    }
    /**
     * The list of categories that are not childs for one node.
     * The list of not categories node childs
     */
    async documentsNotChildCategories(requestParameters, initOverrides) {
        const response = await this.documentsNotChildCategoriesRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Allows setting platforms against the document id provided. Expects all platforms sent to be correct.
     * Associate platforms for the given document id
     */
    async documentsPlatformsAttachRaw(requestParameters, initOverrides) {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling documentsPlatformsAttach.');
        }
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling documentsPlatformsAttach.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters['Authorization'] = await this.configuration.accessToken('keycloakOauth', ['documents-platforms-attach']);
        }
        const response = await this.request({
            path: `/documents/{id}/platforms`.replace(`{${'id'}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: DocumentsPlatformsAttachRequestToJSON(requestParameters.body)
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Allows setting platforms against the document id provided. Expects all platforms sent to be correct.
     * Associate platforms for the given document id
     */
    async documentsPlatformsAttach(requestParameters, initOverrides) {
        await this.documentsPlatformsAttachRaw(requestParameters, initOverrides);
    }
    /**
     * Associate platform to a list of documents
     */
    async documentsPlatformsAttachDocumentsRaw(requestParameters, initOverrides) {
        if (requestParameters.platformId === null ||
            requestParameters.platformId === undefined) {
            throw new runtime.RequiredError('platformId', 'Required parameter requestParameters.platformId was null or undefined when calling documentsPlatformsAttachDocuments.');
        }
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling documentsPlatformsAttachDocuments.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters['Authorization'] = await this.configuration.accessToken('keycloakOauth', ['documents-platforms-attach-documents']);
        }
        const response = await this.request({
            path: `/documents/platforms/{platformId}/documents`.replace(`{${'platformId'}}`, encodeURIComponent(String(requestParameters.platformId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: DocumentsPlatformsAttachDocumentsRequestToJSON(requestParameters.body)
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Associate platform to a list of documents
     */
    async documentsPlatformsAttachDocuments(requestParameters, initOverrides) {
        await this.documentsPlatformsAttachDocumentsRaw(requestParameters, initOverrides);
    }
    /**
     * Create a new platform
     */
    async documentsPlatformsCreateRaw(requestParameters, initOverrides) {
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling documentsPlatformsCreate.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters['Authorization'] = await this.configuration.accessToken('keycloakOauth', ['documents-platforms-create']);
        }
        const response = await this.request({
            path: `/documents/platforms`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: PlatformCreateToJSON(requestParameters.body)
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Create a new platform
     */
    async documentsPlatformsCreate(requestParameters, initOverrides) {
        await this.documentsPlatformsCreateRaw(requestParameters, initOverrides);
    }
    /**
     * Allow (soft) delete of a single platform
     * Allows (soft) deleting a single platform
     */
    async documentsPlatformsDeleteRaw(requestParameters, initOverrides) {
        if (requestParameters.platformId === null ||
            requestParameters.platformId === undefined) {
            throw new runtime.RequiredError('platformId', 'Required parameter requestParameters.platformId was null or undefined when calling documentsPlatformsDelete.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters['Authorization'] = await this.configuration.accessToken('keycloakOauth', ['documents-platforms-delete']);
        }
        const response = await this.request({
            path: `/documents/platforms/{platformId}`.replace(`{${'platformId'}}`, encodeURIComponent(String(requestParameters.platformId))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Allow (soft) delete of a single platform
     * Allows (soft) deleting a single platform
     */
    async documentsPlatformsDelete(requestParameters, initOverrides) {
        await this.documentsPlatformsDeleteRaw(requestParameters, initOverrides);
    }
    /**
     * Delete association between given platform and document
     */
    async documentsPlatformsDetachRaw(requestParameters, initOverrides) {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling documentsPlatformsDetach.');
        }
        if (requestParameters.platformId === null ||
            requestParameters.platformId === undefined) {
            throw new runtime.RequiredError('platformId', 'Required parameter requestParameters.platformId was null or undefined when calling documentsPlatformsDetach.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters['Authorization'] = await this.configuration.accessToken('keycloakOauth', ['documents-platforms-detach']);
        }
        const response = await this.request({
            path: `/documents/{id}/platforms/{platformId}`
                .replace(`{${'id'}}`, encodeURIComponent(String(requestParameters.id)))
                .replace(`{${'platformId'}}`, encodeURIComponent(String(requestParameters.platformId))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Delete association between given platform and document
     */
    async documentsPlatformsDetach(requestParameters, initOverrides) {
        await this.documentsPlatformsDetachRaw(requestParameters, initOverrides);
    }
    /**
     * Delete all platforms association for the given document id
     */
    async documentsPlatformsDetachAllRaw(requestParameters, initOverrides) {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling documentsPlatformsDetachAll.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters['Authorization'] = await this.configuration.accessToken('keycloakOauth', ['documents-platforms-detach-all']);
        }
        const response = await this.request({
            path: `/documents/{id}/platforms`.replace(`{${'id'}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Delete all platforms association for the given document id
     */
    async documentsPlatformsDetachAll(requestParameters, initOverrides) {
        await this.documentsPlatformsDetachAllRaw(requestParameters, initOverrides);
    }
    /**
     * Edit an existing platform
     */
    async documentsPlatformsEditRaw(requestParameters, initOverrides) {
        if (requestParameters.platformId === null ||
            requestParameters.platformId === undefined) {
            throw new runtime.RequiredError('platformId', 'Required parameter requestParameters.platformId was null or undefined when calling documentsPlatformsEdit.');
        }
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling documentsPlatformsEdit.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters['Authorization'] = await this.configuration.accessToken('keycloakOauth', ['documents-platforms-edit']);
        }
        const response = await this.request({
            path: `/documents/platforms/{platformId}`.replace(`{${'platformId'}}`, encodeURIComponent(String(requestParameters.platformId))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: PlatformCreateToJSON(requestParameters.body)
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Edit an existing platform
     */
    async documentsPlatformsEdit(requestParameters, initOverrides) {
        await this.documentsPlatformsEditRaw(requestParameters, initOverrides);
    }
    /**
     * The list of platforms available
     */
    async documentsPlatformsIndexRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }
        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters['Authorization'] = await this.configuration.accessToken('keycloakOauth', ['documents-platforms-index']);
        }
        const response = await this.request({
            path: `/documents/platforms`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters
        }, initOverrides);
        return new runtime.JSONApiResponse(response, jsonValue => PlatformStructureFromJSON(jsonValue));
    }
    /**
     * The list of platforms available
     */
    async documentsPlatformsIndex(requestParameters = {}, initOverrides) {
        const response = await this.documentsPlatformsIndexRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Show a single platform. Useful for editing
     * Show a single platform
     */
    async documentsPlatformsShowRaw(requestParameters, initOverrides) {
        if (requestParameters.platformId === null ||
            requestParameters.platformId === undefined) {
            throw new runtime.RequiredError('platformId', 'Required parameter requestParameters.platformId was null or undefined when calling documentsPlatformsShow.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters['Authorization'] = await this.configuration.accessToken('keycloakOauth', ['documents-platforms-show']);
        }
        const response = await this.request({
            path: `/documents/platforms/{platformId}`.replace(`{${'platformId'}}`, encodeURIComponent(String(requestParameters.platformId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters
        }, initOverrides);
        return new runtime.JSONApiResponse(response, jsonValue => PlatformItemResponseFromJSON(jsonValue));
    }
    /**
     * Show a single platform. Useful for editing
     * Show a single platform
     */
    async documentsPlatformsShow(requestParameters, initOverrides) {
        const response = await this.documentsPlatformsShowRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Add a new publisher
     * Create a new publishers
     */
    async documentsPublishersCreateRaw(requestParameters, initOverrides) {
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling documentsPublishersCreate.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters['Authorization'] = await this.configuration.accessToken('keycloakOauth', ['documents-publishers-create']);
        }
        const response = await this.request({
            path: `/documents/publishers`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: PublisherCreateToJSON(requestParameters.body)
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Add a new publisher
     * Create a new publishers
     */
    async documentsPublishersCreate(requestParameters, initOverrides) {
        await this.documentsPublishersCreateRaw(requestParameters, initOverrides);
    }
    /**
     * Allow soft deletion of a single publisher
     * Allows (soft) deleting a single publisher
     */
    async documentsPublishersDeleteRaw(requestParameters, initOverrides) {
        if (requestParameters.publisherId === null ||
            requestParameters.publisherId === undefined) {
            throw new runtime.RequiredError('publisherId', 'Required parameter requestParameters.publisherId was null or undefined when calling documentsPublishersDelete.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters['Authorization'] = await this.configuration.accessToken('keycloakOauth', ['documents-publishers-delete']);
        }
        const response = await this.request({
            path: `/documents/publishers/{publisherId}`.replace(`{${'publisherId'}}`, encodeURIComponent(String(requestParameters.publisherId))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Allow soft deletion of a single publisher
     * Allows (soft) deleting a single publisher
     */
    async documentsPublishersDelete(requestParameters, initOverrides) {
        await this.documentsPublishersDeleteRaw(requestParameters, initOverrides);
    }
    /**
     * Edit an existing publisher
     * Edit an existing publisher
     */
    async documentsPublishersEditRaw(requestParameters, initOverrides) {
        if (requestParameters.publisherId === null ||
            requestParameters.publisherId === undefined) {
            throw new runtime.RequiredError('publisherId', 'Required parameter requestParameters.publisherId was null or undefined when calling documentsPublishersEdit.');
        }
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling documentsPublishersEdit.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters['Authorization'] = await this.configuration.accessToken('keycloakOauth', ['documents-publishers-edit']);
        }
        const response = await this.request({
            path: `/documents/publishers/{publisherId}`.replace(`{${'publisherId'}}`, encodeURIComponent(String(requestParameters.publisherId))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: PublisherCreateToJSON(requestParameters.body)
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Edit an existing publisher
     * Edit an existing publisher
     */
    async documentsPublishersEdit(requestParameters, initOverrides) {
        await this.documentsPublishersEditRaw(requestParameters, initOverrides);
    }
    /**
     * The list of publishers with filters.
     * The list of publishers available
     */
    async documentsPublishersIndexRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }
        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters['Authorization'] = await this.configuration.accessToken('keycloakOauth', ['documents-publishers-index']);
        }
        const response = await this.request({
            path: `/documents/publishers`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters
        }, initOverrides);
        return new runtime.JSONApiResponse(response, jsonValue => StandardListResponseFromJSON(jsonValue));
    }
    /**
     * The list of publishers with filters.
     * The list of publishers available
     */
    async documentsPublishersIndex(requestParameters = {}, initOverrides) {
        const response = await this.documentsPublishersIndexRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Show a single publisher. Useful for editing
     * Show a single publisher
     */
    async documentsPublishersShowRaw(requestParameters, initOverrides) {
        if (requestParameters.publisherId === null ||
            requestParameters.publisherId === undefined) {
            throw new runtime.RequiredError('publisherId', 'Required parameter requestParameters.publisherId was null or undefined when calling documentsPublishersShow.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters['Authorization'] = await this.configuration.accessToken('keycloakOauth', ['documents-publishers-show']);
        }
        const response = await this.request({
            path: `/documents/publishers/{publisherId}`.replace(`{${'publisherId'}}`, encodeURIComponent(String(requestParameters.publisherId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters
        }, initOverrides);
        return new runtime.JSONApiResponse(response, jsonValue => StandardItemResponseFromJSON(jsonValue));
    }
    /**
     * Show a single publisher. Useful for editing
     * Show a single publisher
     */
    async documentsPublishersShow(requestParameters, initOverrides) {
        const response = await this.documentsPublishersShowRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Show all documents that contain the indicated search term.
     * Searches all documents given a search term.
     */
    async documentsSearchRaw(requestParameters, initOverrides) {
        if (requestParameters.s === null || requestParameters.s === undefined) {
            throw new runtime.RequiredError('s', 'Required parameter requestParameters.s was null or undefined when calling documentsSearch.');
        }
        const queryParameters = {};
        if (requestParameters.s !== undefined) {
            queryParameters['s'] = requestParameters.s;
        }
        if (requestParameters.language !== undefined) {
            queryParameters['language'] = requestParameters.language;
        }
        if (requestParameters.type !== undefined) {
            queryParameters['type'] = requestParameters.type;
        }
        if (requestParameters.strict !== undefined) {
            queryParameters['strict'] = requestParameters.strict;
        }
        if (requestParameters.fuzzy !== undefined) {
            queryParameters['fuzzy'] = requestParameters.fuzzy;
        }
        if (requestParameters.sloppy !== undefined) {
            queryParameters['sloppy'] = requestParameters.sloppy;
        }
        if (requestParameters.categoryId !== undefined) {
            queryParameters['categoryId'] = requestParameters.categoryId;
        }
        if (requestParameters.fields !== undefined) {
            queryParameters['fields'] = requestParameters.fields;
        }
        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }
        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters['Authorization'] = await this.configuration.accessToken('keycloakOauth', ['documents-search']);
        }
        const response = await this.request({
            path: `/documents/search`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters
        }, initOverrides);
        return new runtime.JSONApiResponse(response, jsonValue => SearchListStructureFromJSON(jsonValue));
    }
    /**
     * Show all documents that contain the indicated search term.
     * Searches all documents given a search term.
     */
    async documentsSearch(requestParameters, initOverrides) {
        const response = await this.documentsSearchRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Returns a list of categories associated with a search request.
     * Returns all categories associated with the search request
     */
    async documentsSearchCategoriesRaw(requestParameters, initOverrides) {
        if (requestParameters.s === null || requestParameters.s === undefined) {
            throw new runtime.RequiredError('s', 'Required parameter requestParameters.s was null or undefined when calling documentsSearchCategories.');
        }
        const queryParameters = {};
        if (requestParameters.s !== undefined) {
            queryParameters['s'] = requestParameters.s;
        }
        if (requestParameters.language !== undefined) {
            queryParameters['language'] = requestParameters.language;
        }
        if (requestParameters.type !== undefined) {
            queryParameters['type'] = requestParameters.type;
        }
        if (requestParameters.strict !== undefined) {
            queryParameters['strict'] = requestParameters.strict;
        }
        if (requestParameters.fuzzy !== undefined) {
            queryParameters['fuzzy'] = requestParameters.fuzzy;
        }
        if (requestParameters.sloppy !== undefined) {
            queryParameters['sloppy'] = requestParameters.sloppy;
        }
        if (requestParameters.categoryId !== undefined) {
            queryParameters['categoryId'] = requestParameters.categoryId;
        }
        if (requestParameters.fields !== undefined) {
            queryParameters['fields'] = requestParameters.fields;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters['Authorization'] = await this.configuration.accessToken('keycloakOauth', ['documents-search-categories']);
        }
        const response = await this.request({
            path: `/documents/search/categories`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters
        }, initOverrides);
        return new runtime.JSONApiResponse(response, jsonValue => SearchCategoriesListStructureFromJSON(jsonValue));
    }
    /**
     * Returns a list of categories associated with a search request.
     * Returns all categories associated with the search request
     */
    async documentsSearchCategories(requestParameters, initOverrides) {
        const response = await this.documentsSearchCategoriesRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Returns a **single** document based on provided id. The document must be available meaning is must be enabled and not soft deleted.
     * Shows a single document that is available based on provided id
     */
    async documentsShowRaw(requestParameters, initOverrides) {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling documentsShow.');
        }
        if (requestParameters.locale === null || requestParameters.locale === undefined) {
            throw new runtime.RequiredError('locale', 'Required parameter requestParameters.locale was null or undefined when calling documentsShow.');
        }
        const queryParameters = {};
        if (requestParameters.locale !== undefined) {
            queryParameters['locale'] = requestParameters.locale;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters['Authorization'] = await this.configuration.accessToken('keycloakOauth', [
                'documents-show',
                'documents-show-draft',
                'documents-show-disabled',
                'documents-show-deleted'
            ]);
        }
        const response = await this.request({
            path: `/documents/{id}`.replace(`{${'id'}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters
        }, initOverrides);
        return new runtime.JSONApiResponse(response, jsonValue => DocumentItemStructureFromJSON(jsonValue));
    }
    /**
     * Returns a **single** document based on provided id. The document must be available meaning is must be enabled and not soft deleted.
     * Shows a single document that is available based on provided id
     */
    async documentsShow(requestParameters, initOverrides) {
        const response = await this.documentsShowRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Allows setting tags against the document id provided. Expects all tags sent to be correct.
     * Associate tags for the given document id
     */
    async documentsTagsAttachRaw(requestParameters, initOverrides) {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling documentsTagsAttach.');
        }
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling documentsTagsAttach.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters['Authorization'] = await this.configuration.accessToken('keycloakOauth', ['documents-tags-attach']);
        }
        const response = await this.request({
            path: `/documents/{id}/tags`.replace(`{${'id'}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: DocumentsAuthorsAttachRequestToJSON(requestParameters.body)
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Allows setting tags against the document id provided. Expects all tags sent to be correct.
     * Associate tags for the given document id
     */
    async documentsTagsAttach(requestParameters, initOverrides) {
        await this.documentsTagsAttachRaw(requestParameters, initOverrides);
    }
    /**
     * Add a new tag
     * Create a new tag
     */
    async documentsTagsCreateRaw(requestParameters, initOverrides) {
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling documentsTagsCreate.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters['Authorization'] = await this.configuration.accessToken('keycloakOauth', ['documents-tags-create']);
        }
        const response = await this.request({
            path: `/documents/tags`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: TagCreateToJSON(requestParameters.body)
        }, initOverrides);
        return new runtime.JSONApiResponse(response, jsonValue => DocumentCreatedStructureFromJSON(jsonValue));
    }
    /**
     * Add a new tag
     * Create a new tag
     */
    async documentsTagsCreate(requestParameters, initOverrides) {
        const response = await this.documentsTagsCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Allow soft deletion of a single tag
     * Allows (soft) deleting a single tag
     */
    async documentsTagsDeleteRaw(requestParameters, initOverrides) {
        if (requestParameters.tagId === null || requestParameters.tagId === undefined) {
            throw new runtime.RequiredError('tagId', 'Required parameter requestParameters.tagId was null or undefined when calling documentsTagsDelete.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters['Authorization'] = await this.configuration.accessToken('keycloakOauth', ['documents-tags-delete']);
        }
        const response = await this.request({
            path: `/documents/tags/{tagId}`.replace(`{${'tagId'}}`, encodeURIComponent(String(requestParameters.tagId))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Allow soft deletion of a single tag
     * Allows (soft) deleting a single tag
     */
    async documentsTagsDelete(requestParameters, initOverrides) {
        await this.documentsTagsDeleteRaw(requestParameters, initOverrides);
    }
    /**
     * Delete association between given tag and document
     * Delete association between given tag and document
     */
    async documentsTagsDetachRaw(requestParameters, initOverrides) {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling documentsTagsDetach.');
        }
        if (requestParameters.tagId === null || requestParameters.tagId === undefined) {
            throw new runtime.RequiredError('tagId', 'Required parameter requestParameters.tagId was null or undefined when calling documentsTagsDetach.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters['Authorization'] = await this.configuration.accessToken('keycloakOauth', ['documents-tags-detach']);
        }
        const response = await this.request({
            path: `/documents/{id}/tags/{tagId}`
                .replace(`{${'id'}}`, encodeURIComponent(String(requestParameters.id)))
                .replace(`{${'tagId'}}`, encodeURIComponent(String(requestParameters.tagId))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Delete association between given tag and document
     * Delete association between given tag and document
     */
    async documentsTagsDetach(requestParameters, initOverrides) {
        await this.documentsTagsDetachRaw(requestParameters, initOverrides);
    }
    /**
     * Delete all tag association for the given document id
     * Delete all tags association for the given document id
     */
    async documentsTagsDetachAllRaw(requestParameters, initOverrides) {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling documentsTagsDetachAll.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters['Authorization'] = await this.configuration.accessToken('keycloakOauth', ['documents-tags-detach-all']);
        }
        const response = await this.request({
            path: `/documents/{id}/tags`.replace(`{${'id'}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Delete all tag association for the given document id
     * Delete all tags association for the given document id
     */
    async documentsTagsDetachAll(requestParameters, initOverrides) {
        await this.documentsTagsDetachAllRaw(requestParameters, initOverrides);
    }
    /**
     * Edit an existing tag
     * Edit an existing tag
     */
    async documentsTagsEditRaw(requestParameters, initOverrides) {
        if (requestParameters.tagId === null || requestParameters.tagId === undefined) {
            throw new runtime.RequiredError('tagId', 'Required parameter requestParameters.tagId was null or undefined when calling documentsTagsEdit.');
        }
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling documentsTagsEdit.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters['Authorization'] = await this.configuration.accessToken('keycloakOauth', ['documents-tags-edit']);
        }
        const response = await this.request({
            path: `/documents/tags/{tagId}`.replace(`{${'tagId'}}`, encodeURIComponent(String(requestParameters.tagId))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: TagCreateToJSON(requestParameters.body)
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Edit an existing tag
     * Edit an existing tag
     */
    async documentsTagsEdit(requestParameters, initOverrides) {
        await this.documentsTagsEditRaw(requestParameters, initOverrides);
    }
    /**
     * The list of tags with filters.
     * The list of tags available
     */
    async documentsTagsIndexRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }
        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }
        if (requestParameters.ids) {
            queryParameters['ids'] = requestParameters.ids.join(runtime.COLLECTION_FORMATS['csv']);
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters['Authorization'] = await this.configuration.accessToken('keycloakOauth', ['documents-tags-index']);
        }
        const response = await this.request({
            path: `/documents/tags`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters
        }, initOverrides);
        return new runtime.JSONApiResponse(response, jsonValue => StandardListResponseFromJSON(jsonValue));
    }
    /**
     * The list of tags with filters.
     * The list of tags available
     */
    async documentsTagsIndex(requestParameters = {}, initOverrides) {
        const response = await this.documentsTagsIndexRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Allows searching for tags. Useful for autocomplete.
     * Search for tags
     */
    async documentsTagsSearchRaw(requestParameters, initOverrides) {
        if (requestParameters.s === null || requestParameters.s === undefined) {
            throw new runtime.RequiredError('s', 'Required parameter requestParameters.s was null or undefined when calling documentsTagsSearch.');
        }
        const queryParameters = {};
        if (requestParameters.s !== undefined) {
            queryParameters['s'] = requestParameters.s;
        }
        if (requestParameters.isFullTextSearch !== undefined) {
            queryParameters['isFullTextSearch'] = requestParameters.isFullTextSearch;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters['Authorization'] = await this.configuration.accessToken('keycloakOauth', ['documents-tags-search']);
        }
        const response = await this.request({
            path: `/documents/tags/search`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters
        }, initOverrides);
        return new runtime.JSONApiResponse(response, jsonValue => StandardListResponseFromJSON(jsonValue));
    }
    /**
     * Allows searching for tags. Useful for autocomplete.
     * Search for tags
     */
    async documentsTagsSearch(requestParameters, initOverrides) {
        const response = await this.documentsTagsSearchRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Show a single tag. Useful for editing
     * Show a single tag
     */
    async documentsTagsShowRaw(requestParameters, initOverrides) {
        if (requestParameters.tagId === null || requestParameters.tagId === undefined) {
            throw new runtime.RequiredError('tagId', 'Required parameter requestParameters.tagId was null or undefined when calling documentsTagsShow.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters['Authorization'] = await this.configuration.accessToken('keycloakOauth', ['documents-tags-show']);
        }
        const response = await this.request({
            path: `/documents/tags/{tagId}`.replace(`{${'tagId'}}`, encodeURIComponent(String(requestParameters.tagId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters
        }, initOverrides);
        return new runtime.JSONApiResponse(response, jsonValue => StandardItemResponseFromJSON(jsonValue));
    }
    /**
     * Show a single tag. Useful for editing
     * Show a single tag
     */
    async documentsTagsShow(requestParameters, initOverrides) {
        const response = await this.documentsTagsShowRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * You can add a new translation to a document based on provided document id. You can add both title and subjects.
     * Create a new translation for a document
     */
    async documentsTranslationsAttachRaw(requestParameters, initOverrides) {
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling documentsTranslationsAttach.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters['Authorization'] = await this.configuration.accessToken('keycloakOauth', ['documents-translations-attach']);
        }
        const response = await this.request({
            path: `/documents/translations`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: DocumentTranslationCreateToJSON(requestParameters.body)
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     * You can add a new translation to a document based on provided document id. You can add both title and subjects.
     * Create a new translation for a document
     */
    async documentsTranslationsAttach(requestParameters, initOverrides) {
        await this.documentsTranslationsAttachRaw(requestParameters, initOverrides);
    }
    /**
     * You can edit an existing translations (titles, subjects) of a given document.
     * Edit a translation of a document
     */
    async documentsTranslationsAttachEditRaw(requestParameters, initOverrides) {
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling documentsTranslationsAttachEdit.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters['Authorization'] = await this.configuration.accessToken('keycloakOauth', ['documents-translations-attach-edit']);
        }
        const response = await this.request({
            path: `/documents/translations`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: DocumentTranslationCreateToJSON(requestParameters.body)
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     * You can edit an existing translations (titles, subjects) of a given document.
     * Edit a translation of a document
     */
    async documentsTranslationsAttachEdit(requestParameters, initOverrides) {
        await this.documentsTranslationsAttachEditRaw(requestParameters, initOverrides);
    }
    /**
     * Allows deleting a single translation based on document id and language id. Delete both the title and subject translation.
     * Delete a documents\'s translation of a specified language
     */
    async documentsTranslationsDetachRaw(requestParameters, initOverrides) {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling documentsTranslationsDetach.');
        }
        if (requestParameters.languageId === null ||
            requestParameters.languageId === undefined) {
            throw new runtime.RequiredError('languageId', 'Required parameter requestParameters.languageId was null or undefined when calling documentsTranslationsDetach.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters['Authorization'] = await this.configuration.accessToken('keycloakOauth', ['documents-translations-detach']);
        }
        const response = await this.request({
            path: `/documents/{id}/translations/{languageId}`
                .replace(`{${'id'}}`, encodeURIComponent(String(requestParameters.id)))
                .replace(`{${'languageId'}}`, encodeURIComponent(String(requestParameters.languageId))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Allows deleting a single translation based on document id and language id. Delete both the title and subject translation.
     * Delete a documents\'s translation of a specified language
     */
    async documentsTranslationsDetach(requestParameters, initOverrides) {
        await this.documentsTranslationsDetachRaw(requestParameters, initOverrides);
    }
    /**
     * Finds all translations related to a document and deletes all of them, regardless of the language.
     * Delete all translations of a given document
     */
    async documentsTranslationsDetachAllRaw(requestParameters, initOverrides) {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling documentsTranslationsDetachAll.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters['Authorization'] = await this.configuration.accessToken('keycloakOauth', ['documents-translations-detach-all']);
        }
        const response = await this.request({
            path: `/documents/{id}/translations`.replace(`{${'id'}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Finds all translations related to a document and deletes all of them, regardless of the language.
     * Delete all translations of a given document
     */
    async documentsTranslationsDetachAll(requestParameters, initOverrides) {
        await this.documentsTranslationsDetachAllRaw(requestParameters, initOverrides);
    }
    /**
     * Returns the list of available document types
     */
    async documentsTypesIndexRaw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters['Authorization'] = await this.configuration.accessToken('keycloakOauth', ['documents-types-index']);
        }
        const response = await this.request({
            path: `/documents/types`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters
        }, initOverrides);
        return new runtime.JSONApiResponse(response, jsonValue => DocumentTypesListStructureFromJSON(jsonValue));
    }
    /**
     * Returns the list of available document types
     */
    async documentsTypesIndex(initOverrides) {
        const response = await this.documentsTypesIndexRaw(initOverrides);
        return await response.value();
    }
    /**
     * Create user\'s custom attributes on API backend
     */
    async documentsUsersCreateRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters['Authorization'] = await this.configuration.accessToken('keycloakOauth', ['documents-users-create']);
        }
        const response = await this.request({
            path: `/documents/users`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: UserCreateToJSON(requestParameters.body)
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Create user\'s custom attributes on API backend
     */
    async documentsUsersCreate(requestParameters = {}, initOverrides) {
        const response = await this.documentsUsersCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Delete (anonymise) user
     */
    async documentsUsersDeleteRaw(requestParameters, initOverrides) {
        if (requestParameters.username === null || requestParameters.username === undefined) {
            throw new runtime.RequiredError('username', 'Required parameter requestParameters.username was null or undefined when calling documentsUsersDelete.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters['Authorization'] = await this.configuration.accessToken('keycloakOauth', ['documents-users-delete']);
        }
        const response = await this.request({
            path: `/documents/users/{username}`.replace(`{${'username'}}`, encodeURIComponent(String(requestParameters.username))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Delete (anonymise) user
     */
    async documentsUsersDelete(requestParameters, initOverrides) {
        await this.documentsUsersDeleteRaw(requestParameters, initOverrides);
    }
    /**
     * Update a user\'s custom attributes
     */
    async documentsUsersEditRaw(requestParameters, initOverrides) {
        if (requestParameters.username === null || requestParameters.username === undefined) {
            throw new runtime.RequiredError('username', 'Required parameter requestParameters.username was null or undefined when calling documentsUsersEdit.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters['Authorization'] = await this.configuration.accessToken('keycloakOauth', ['documents-users-update']);
        }
        const response = await this.request({
            path: `/documents/users/{username}`.replace(`{${'username'}}`, encodeURIComponent(String(requestParameters.username))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UserUpdateToJSON(requestParameters.body)
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Update a user\'s custom attributes
     */
    async documentsUsersEdit(requestParameters, initOverrides) {
        await this.documentsUsersEditRaw(requestParameters, initOverrides);
    }
    /**
     * Update the user\'s custom attributes based on token
     */
    async documentsUsersEditSelfRaw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters['Authorization'] = await this.configuration.accessToken('keycloakOauth', ['documents-users-update-self']);
        }
        const response = await this.request({
            path: `/documents/users/self`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Update the user\'s custom attributes based on token
     */
    async documentsUsersEditSelf(initOverrides) {
        const response = await this.documentsUsersEditSelfRaw(initOverrides);
        return await response.value();
    }
    /**
     * List the users with their custom attributes
     */
    async documentsUsersIndexRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }
        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }
        if (requestParameters.usernames) {
            queryParameters['usernames'] = requestParameters.usernames.join(runtime.COLLECTION_FORMATS['csv']);
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters['Authorization'] = await this.configuration.accessToken('keycloakOauth', ['documents-users-index']);
        }
        const response = await this.request({
            path: `/documents/users`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters
        }, initOverrides);
        return new runtime.JSONApiResponse(response, jsonValue => DocumentsUsersIndex200ResponseFromJSON(jsonValue));
    }
    /**
     * List the users with their custom attributes
     */
    async documentsUsersIndex(requestParameters = {}, initOverrides) {
        const response = await this.documentsUsersIndexRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Show a single user\'s custom attributes
     */
    async documentsUsersShowRaw(requestParameters, initOverrides) {
        if (requestParameters.username === null || requestParameters.username === undefined) {
            throw new runtime.RequiredError('username', 'Required parameter requestParameters.username was null or undefined when calling documentsUsersShow.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters['Authorization'] = await this.configuration.accessToken('keycloakOauth', ['documents-users-show']);
        }
        const response = await this.request({
            path: `/documents/users/{username}`.replace(`{${'username'}}`, encodeURIComponent(String(requestParameters.username))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters
        }, initOverrides);
        return new runtime.JSONApiResponse(response, jsonValue => DocumentsUsersShow200ResponseFromJSON(jsonValue));
    }
    /**
     * Show a single user\'s custom attributes
     */
    async documentsUsersShow(requestParameters, initOverrides) {
        const response = await this.documentsUsersShowRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Show the user\'s custom attributes based on token
     */
    async documentsUsersShowSelfRaw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters['Authorization'] = await this.configuration.accessToken('keycloakOauth', ['documents-users-show-self']);
        }
        const response = await this.request({
            path: `/documents/users/self`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters
        }, initOverrides);
        return new runtime.JSONApiResponse(response, jsonValue => DocumentsUsersShow200ResponseFromJSON(jsonValue));
    }
    /**
     * Show the user\'s custom attributes based on token
     */
    async documentsUsersShowSelf(initOverrides) {
        const response = await this.documentsUsersShowSelfRaw(initOverrides);
        return await response.value();
    }
    /**
     * Allows creating a video document type
     */
    async documentsVideoCreateRaw(requestParameters, initOverrides) {
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling documentsVideoCreate.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters['Authorization'] = await this.configuration.accessToken('keycloakOauth', ['documents-video-create']);
        }
        const response = await this.request({
            path: `/documents/video`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: DocumentVideoCreateToJSON(requestParameters.body)
        }, initOverrides);
        return new runtime.JSONApiResponse(response, jsonValue => DocumentCreatedStructureFromJSON(jsonValue));
    }
    /**
     * Allows creating a video document type
     */
    async documentsVideoCreate(requestParameters, initOverrides) {
        const response = await this.documentsVideoCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Allows editing a video document type
     */
    async documentsVideoUpdateRaw(requestParameters, initOverrides) {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling documentsVideoUpdate.');
        }
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling documentsVideoUpdate.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters['Authorization'] = await this.configuration.accessToken('keycloakOauth', ['documents-video-update']);
        }
        const response = await this.request({
            path: `/documents/video/{id}`.replace(`{${'id'}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: DocumentVideoUpdateToJSON(requestParameters.body)
        }, initOverrides);
        return new runtime.JSONApiResponse(response, jsonValue => DocumentCreatedStructureFromJSON(jsonValue));
    }
    /**
     * Allows editing a video document type
     */
    async documentsVideoUpdate(requestParameters, initOverrides) {
        const response = await this.documentsVideoUpdateRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Update terms and conditions
     */
    async termsAndConditionsEditRaw(requestParameters, initOverrides) {
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling termsAndConditionsEdit.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters['Authorization'] = await this.configuration.accessToken('keycloakOauth', ['terms-conditions-edit']);
        }
        const response = await this.request({
            path: `/documents/termsAndConditions`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: TermsAndConditionsStructureToJSON(requestParameters.body)
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Update terms and conditions
     */
    async termsAndConditionsEdit(requestParameters, initOverrides) {
        await this.termsAndConditionsEditRaw(requestParameters, initOverrides);
    }
    /**
     * The list of terms and conditions
     */
    async termsAndConditionsIndexRaw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters['Authorization'] = await this.configuration.accessToken('keycloakOauth', ['terms-conditions-index']);
        }
        const response = await this.request({
            path: `/documents/termsAndConditions`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters
        }, initOverrides);
        return new runtime.JSONApiResponse(response, jsonValue => TermsAndConditionsArrayFromJSON(jsonValue));
    }
    /**
     * The list of terms and conditions
     */
    async termsAndConditionsIndex(initOverrides) {
        const response = await this.termsAndConditionsIndexRaw(initOverrides);
        return await response.value();
    }
}
/**
 * @export
 */
export const DocumentsIndexTypeEnum = {
    Book: 'book',
    Article: 'article',
    Video: 'video',
    News: 'news',
    Image: 'image',
    Generic: 'generic',
    Exercise: 'exercise'
};
/**
 * @export
 */
export const DocumentsIndexStatusEnum = {
    Enabled: 'enabled',
    Draft: 'draft',
    Disabled: 'disabled'
};
/**
 * @export
 */
export const DocumentsSearchTypeEnum = {
    Book: 'book',
    Article: 'article',
    Video: 'video',
    News: 'news',
    Image: 'image',
    Generic: 'generic',
    Exercise: 'exercise'
};
/**
 * @export
 */
export const DocumentsSearchCategoriesTypeEnum = {
    Book: 'book',
    Article: 'article',
    Video: 'video',
    News: 'news',
    Image: 'image',
    Generic: 'generic',
    Exercise: 'exercise'
};
